import { render } from "./BraceletManagement.vue?vue&type=template&id=2ec40154&scoped=true"
import script from "./BraceletManagement.vue?vue&type=script&lang=js"
export * from "./BraceletManagement.vue?vue&type=script&lang=js"

import "./BraceletManagement.vue?vue&type=style&index=0&id=2ec40154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec40154"]])

export default __exports__